import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { asIndexTab, type IndexTab } from '@/features/ai/ai-href';
import { IndexDetailPage } from '@/features/ai/rag/rag-pages';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** Un index : conversation sourcée, recherche, documents. */
export const Route = createFileRoute('/$tenant/projects/$projectId/assistant/$indexId')({
  validateSearch: (search: Record<string, unknown>): { tab: IndexTab } => ({
    tab: asIndexTab(search['tab']),
  }),
  component: IndexDetailRoute,
});

function IndexDetailRoute() {
  const { tenant, projectId, indexId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="assistant"
      crumbs={[
        { label: t('nav.items.assistant') },
        { label: <EntityName tenantId={tenant} kind="ragIndex" id={indexId} scope={{ projectId }} /> },
      ]}
    >
      <IndexDetailPage
        tenantId={tenant}
        projectId={projectId}
        indexId={indexId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
